import React, { useEffect, useState } from "react";
import colors from "Assets/sass/core/vars.scss";
import {
  getAbbvTimezone,
  GetFormatForMoment,
  getFormattedDateByTimeZone,
} from "./tools";
import "./style.scss";
import { Tooltip } from 'Components';
import { Typography } from "@mui/material";
import moment from "moment";
import momentTz from "moment-timezone";

function formatRangeDate(value, timezone, newFormat) {
  if (value == null || value === "") return null;
  const num = Number(value);
  let m;
  if (Number.isInteger(num)) {
    const asMs = value.toString().length > 10 ? num : num * 1000;
    m = momentTz(asMs);
  } else if (typeof value === "string") {
    m = momentTz.utc(value);
  } else {
    return null;
  }
  const toFormat = timezone ? m.tz(timezone) : m;
  return toFormat.isValid() ? toFormat.format(newFormat) : null;
}

export const getDateTime = ({
  date,
  timezone,
  dateFormat,
  timeFormat,
  fromNow = false,
  locale = "en",
  range = { start: '', end: '' },
  customFormat = false,
  onlyHour = false
}) => {
  const { start, end } = range
  let newFormat = GetFormatForMoment(dateFormat, customFormat);

  if (timeFormat && !onlyHour) {
    newFormat = `${newFormat} ${timeFormat}`;
  }

  if (onlyHour) {
    newFormat = `${timeFormat}`;
  }

  let formatDate;
  if (date) {
    formatDate = getFormattedDateByTimeZone(date, timezone, newFormat, fromNow, locale);
  }

  if (start && end && timezone) {
    const startDate = formatRangeDate(start, timezone, newFormat);
    const endDate = formatRangeDate(end, timezone, newFormat);

    if (startDate && endDate) {
      formatDate = `${startDate} - ${endDate}`;
    }
  }

  const abbvDate = start || date;
  const abbvTimezone = getAbbvTimezone(timezone, abbvDate);

  return {
    date: formatDate || date?.toString(),
    abbr: abbvTimezone
  }
}

const Timezone = ({
  date,
  timezone = "US/Eastern",
  dateFormat = "d/m/Y",
  timeFormat,
  onlyDate = false,
  onlyHour = false,
  range = { start: '', end: '' },
  className = "",
  placement = "bottom",
  fromNow = false,
  locale = "en",
  customFormat = false,
  noWrap = true,
  oneControl = false,
  noPopover = false,
  refresh = 0
}) => {
  const [newDate, setNewDate] = useState("");
  const [abbr, setAbbr] = useState("");

  useEffect(() => {
    const currentDateTime = getDateTime({ date, timezone, dateFormat, timeFormat, fromNow, locale, range, customFormat, onlyHour });

    setAbbr(`, ${currentDateTime?.abbr}`);
    setNewDate(currentDateTime?.date);
  }, [date, timezone, dateFormat, timeFormat, refresh, locale, range?.start, range?.end]);

  return (
    !oneControl
      ?
      <div className="gtc-timezone">
        <Typography
          style={
            !className
              ? {
                fontSize: "14px",
                fontWeight: "400",
                color: colors.black,
              } : {}}
          className={className}
        >
          {newDate}
        </Typography>
        {!onlyDate && (
          noPopover ? (
            <Typography
              style={
                !className
                  ? {
                    fontSize: "14px",
                    fontWeight: "400",
                    color: colors.black,
                  } : {}}
              className={className}
            >
              {abbr}
            </Typography>
          ) : (
            <Tooltip placement={placement} title={timezone}>
              <div>
                <Typography
                  style={
                    !className
                      ? {
                        fontSize: "14px",
                        fontWeight: "400",
                        color: colors.black,
                      } : {}}
                  className={className}
                >
                  {abbr}
                </Typography>
              </div>
            </Tooltip>
          )
        )}
      </div>
      :
      <div className="gtc-timezone" style={{ display: 'inline-block' }}>
        {noPopover ? (
          <Typography
            style={
              !className
                ? {
                  fontSize: "14px",
                  fontWeight: "400",
                  color: colors.black,
                } : {}}
            className={className}
          >
            {`${newDate} ${abbr}`}
          </Typography>
        ) : (
          <Tooltip placement={placement} title={timezone}>
            <div>
              <Typography
                style={
                  !className
                    ? {
                      fontSize: "14px",
                      fontWeight: "400",
                      color: colors.black,
                    } : {}}
                className={className}
              >
                {`${newDate} ${abbr}`}
              </Typography>
            </div>
          </Tooltip>
        )}
      </div>
  );
};

export default Timezone;